module.exports = __webpack_public_path__ + "img/msapplication-icon-144x144.c91d4889.png";